// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071241/js/" + chunkId + "." + {"44":"80951783","225":"5140c62e","481":"bf81e219","486":"e0e69e4d","770":"2676b85b"}[chunkId] + ".0.40759626773531554.chunk.js";
};